import * as classnames from "classnames";

import { Msg } from "..";
import { ChallengeTakenBy } from "../../services/enums";

/**
 * Prop interface
 */
export interface ApplicantChallengeHeaderMenuProps {
  isOpen?: boolean;
  hasSwitchLanguage?: boolean;
  hasSwitchFrontendTemplate?: boolean;
  hasVersionCommand?: boolean;
  hasSwitchTakenBy?: boolean;
  hasFrontendChallenge?: boolean;
  isUsingVsCodeEditor?: boolean;
  takenBy?: ChallengeTakenBy;
  onReset?: () => void;
  onSwitchProgrammingLanguage?: () => void;
  onSwitchFrontendTemplate?: () => void;
  onVersionCommand?: () => void;
  onShowTestInformation?: () => void;
  onInitializeRemote?: () => void;
  onUpdateEnv?: () => void;
  onSubmit?: () => void;
  onSwitchTakenBy?: ({ takenBy }: { takenBy: ChallengeTakenBy }) => void;
  className?: string;
}

/**
 * React Component
 */
export default function ApplicantChallengeHeaderMenu({
  isOpen = false,
  hasSwitchLanguage = false,
  hasSwitchFrontendTemplate = false,
  hasVersionCommand = false,
  hasSwitchTakenBy = false,
  isUsingVsCodeEditor,
  onReset,
  onSwitchProgrammingLanguage,
  onSwitchFrontendTemplate,
  onVersionCommand,
  onShowTestInformation,
  onInitializeRemote,
  onUpdateEnv,
  onSubmit,
  onSwitchTakenBy,
  takenBy,
  className,
}: ApplicantChallengeHeaderMenuProps) {
  const rootStyle = classnames("code-c-applicant-challenge-header-menu", {
    "is-open": isOpen,
    [`${className}`]: Boolean(className),
  });

  function onClickSwitchTakenBy() {
    if (typeof onSwitchTakenBy === "function") {
      onSwitchTakenBy({
        takenBy:
          takenBy === ChallengeTakenBy.LocalMachine
            ? ChallengeTakenBy.WebBrowser
            : ChallengeTakenBy.LocalMachine,
      });
    }
  }

  return (
    <div className={rootStyle} aria-hidden={!isOpen}>
      <ul
        className="code-c-applicant-challenge-header-menu__container"
        role="menu"
      >
        {takenBy !== ChallengeTakenBy.LocalMachine && (
          <>
            <li className="code-c-applicant-challenge-header-menu__item">
              <a role="menuitem" onClick={onReset}>
                <Msg id={"button.resetChallenge"} />
              </a>
            </li>
            {hasSwitchLanguage && (
              <li className="code-c-applicant-challenge-header-menu__item">
                <a role="menuitem" onClick={onSwitchProgrammingLanguage}>
                  <Msg id={"button.switchLanguage"} />
                </a>
              </li>
            )}
            {hasSwitchFrontendTemplate && (
              <li className="code-c-applicant-challenge-header-menu__item">
                <a role="menuitem" onClick={onSwitchFrontendTemplate}>
                  <Msg id={"button.switchFrontendTemplate"} />
                </a>
              </li>
            )}
            {hasVersionCommand && (
              <li className="code-c-applicant-challenge-header-menu__item">
                <a role="menuitem" onClick={onVersionCommand}>
                  <Msg id={"button.languageVersion"} />
                </a>
              </li>
            )}
          </>
        )}
        {hasSwitchTakenBy && (
          <li className="code-c-applicant-challenge-header-menu__item">
            <a role="menuitem" onClick={onClickSwitchTakenBy}>
              <Msg
                id={
                  takenBy === ChallengeTakenBy.LocalMachine
                    ? "start-challenge.button.web"
                    : "start-challenge.button.local"
                }
              />
            </a>
          </li>
        )}
        {!isUsingVsCodeEditor && (
          <>
            <li className="code-c-applicant-challenge-header-menu__item">
              <a role="menuitem" onClick={onShowTestInformation}>
                <Msg id={"button.testInfo"} />
              </a>
            </li>
            <li className="code-c-applicant-challenge-header-menu__item">
              <a role="menuitem" onClick={onInitializeRemote}>
                <Msg id={"button.initializeEnv"} />
              </a>
            </li>
          </>
        )}
      </ul>
    </div>
  );
}
